import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'

import Card from '@/components/Card'
import PaginationTable from '@/components/PaginationTable'

import columns from './columns'

import './index.scss'

import { Link } from 'react-router-dom'

import messages from './messages'

const GroupList = ({ groups, onView, sortingColumn }: any) => {
  const intl = useIntl()

  return (
    <Card>
      <Card.Content>
        <p>
          <FormattedMessage
            {...messages.description}
            values={{
              userAttributesLink: (
                <Link to="/organization/users/attributes">
                  <FormattedMessage {...messages.userAttributes} />
                </Link>
              )
            }}
          />
        </p>
        {groups.length > 0 ? (
          <PaginationTable
            className="group-list__table"
            columns={columns({ intl, onView })}
            rowKey="id"
            rows={groups}
            sortingColumn={sortingColumn}
          />
        ) : (
          <p className="no-members flex-center">
            <FormattedMessage {...messages.noGroups} />
          </p>
        )}
      </Card.Content>
    </Card>
  )
}

GroupList.displayName = 'GroupList'

GroupList.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object),

  onView: PropTypes.func.isRequired,
  sortingColumn: PropTypes.object
}

GroupList.defaultProps = {
  groups: [],
  sortingColumn: null
}

export default GroupList
